import React, { useState, useEffect } from 'react';
import { convertToPKR, formatCurrency } from '../utils/currencyConverter';

const PriceDisplay = ({ amount, showBoth = false, displayCurrency = 'GBP', className = '' }) => {
  const [pkrAmount, setPkrAmount] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const convertPrice = async () => {
      if (amount != null && !isNaN(amount) && (displayCurrency === 'PKR' || showBoth)) {
        if (pkrAmount == null) setLoading(true);
        const pkr = await convertToPKR(amount);
        setPkrAmount(pkr);
        setLoading(false);
      } else {
        setLoading(false);
      }
    };

    convertPrice();
  }, [amount, displayCurrency, showBoth]);

  if (amount == null || amount === '' || isNaN(amount)) {
    return <span className={className}>-</span>;
  }

  // Show only PKR (amount is assumed in GBP) when explicitly requested
  if (displayCurrency === 'PKR') {
    if (loading) {
      return <span className={className}>Rs ...</span>;
    }
    return <span className={className}>{formatCurrency(pkrAmount, 'PKR')}</span>;
  }

  // Default: show only GBP everywhere
  return <span className={className}>{formatCurrency(amount, 'GBP')}</span>;
};

export default PriceDisplay;
